import React, { useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../App';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { API, login } = useContext(AuthContext);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double-processing in React StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        // Read session_id from URL fragment (e.g. /auth/callback#session_id=abc)
        const hash = window.location.hash || '';
        const params = new URLSearchParams(hash.replace(/^#/, ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('שגיאה', { description: 'לא נמצא session_id בכתובת. נסה/י שוב.' });
          navigate('/auth');
          return;
        }

        // Exchange session_id for JWT via our backend
        const response = await axios.post(`${API}/auth/google/callback`, { session_id: sessionId });
        const { access_token, user } = response.data;

        // Use the existing JWT login flow → stores token + user
        login(access_token, user, true);

        // Clear the hash from URL and redirect to home
        window.history.replaceState({}, document.title, window.location.pathname);

        toast.success(`ברוך הבא, ${user.full_name}!`);
        navigate('/');
      } catch (err) {
        const detail = err.response?.data?.detail || 'שגיאה בהתחברות דרך Google';
        toast.error('שגיאה', { description: detail });
        navigate('/auth');
      }
    };

    processCallback();
  }, [API, login, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-emerald-50 flex items-center justify-center" dir="rtl">
      <div className="bg-white rounded-3xl shadow-2xl p-10 text-center max-w-md mx-4">
        <div className="relative w-20 h-20 mx-auto mb-6">
          <div className="absolute inset-0 rounded-full border-4 border-blue-200" />
          <div className="absolute inset-0 rounded-full border-4 border-blue-600 border-t-transparent animate-spin" />
          <div className="absolute inset-0 flex items-center justify-center text-2xl">🎾</div>
        </div>
        <h1 className="text-2xl font-black text-slate-900 mb-2">מתחבר/ת לחשבון...</h1>
        <p className="text-sm text-slate-500">רק רגע, מאמת/ת את החשבון שלך דרך Google</p>
      </div>
    </div>
  );
};

export default AuthCallback;
